import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import {CommonService} from './common.service';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';

@Injectable({
  providedIn: 'root'
})
export class NativeStorageProxy {
  constructor(
    private common: CommonService,
    private nativeStorage: NativeStorage,
    private storage: Storage,
  ) { }

  setItem(reference: string, value: any): Promise<any> {
    return this.common.isApp ? this.nativeStorage.setItem(reference, value) : this.storage.set(reference, JSON.stringify(value));
  }

  getItem<T>(reference: string, defaultValue?: T): Promise<T> {
    return this.getItemAndIsDefaultInfo(reference, defaultValue).then(result => result.value);
  }

  getItemAndIsDefaultInfo<T>(reference: string, defaultValue?: T): Promise<{value: T, isDefault: boolean}> {
    const defaultResult = { value: defaultValue, isDefault: true };
    const promise = this.common.isApp
      ? this.nativeStorage.getItem(reference).then(value => value ? { value, isDefault: false } : defaultResult)
      : this.storage.get(reference).then(value => value ?
        { value: JSON.parse(value), isDefault: false } :
        defaultResult);
    return promise.catch(() => defaultResult);
  }

  keys(): Promise<any> {
    return this.common.isApp ? this.nativeStorage.keys() : this.storage.keys();
  }

  remove(reference: string): Promise<any> {
    return this.common.isApp ? this.nativeStorage.remove(reference) : this.storage.remove(reference);
  }

  clear(): Promise<any> {
    return this.common.isApp ? this.nativeStorage.clear() : this.storage.clear();
  }

  create(): Promise<any>{
    return this.storage.create();
  }
}
